import * as React from 'react'

import EasiForm from 'components/forms/EasiForm'

import { CmsComponentSlot } from '@grandvisionhq/bloomreach'
import { Container } from '@grandvisionhq/elements'
import { NextPage } from '@grandvisionhq/next'
import { compose } from '@grandvisionhq/utils'

import { withCms, withLayout } from '../cms'

import '@grandvisionhq/customer-support/dist/index.css'

const CustomerSupportPage: NextPage = () => (
  <>
    <CmsComponentSlot path="main/top-container" />
    <Container className="contact-layout">
      <div className="contact-layout-form">
        <h2 className="typography-heading typography-heading--small">Contact</h2>
        <EasiForm />
      </div>
      <p>
        Générale d&apos;Optique, en tant que responsable de traitement, traite vos données à
        caractère personnel à des fins de gestion et de suivi de vos requêtes, réclamations, ou
        toute autre question. Pour plus d’informations sur l’exercice de vos droits et la protection
        de vos données personnelles, <a href="/privacy">cliquez ici.</a>
      </p>
      <p>
        <a href="/terms">
          ** Voir les <span className="underline">CGU</span>.
        </a>
      </p>
    </Container>
    <CmsComponentSlot path="main/bottom-container" />
  </>
)

export default compose(withCms(), withLayout())(CustomerSupportPage)
